import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import cancelIcon from "../../assets/images/cancel_job_application_tracker.svg";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";
import { Button } from "./components/Button";

export const WeeklyContestCard: React.FC = () => {
  const navigate = usePartnerAwareNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative bg-bg-primary rounded p-8 transition-transform duration-500 group overflow-hidden flex flex-col h-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        boxShadow: isHovered
          ? "0 8px 32px rgba(255, 173, 115, 0.15)"
          : "0 4px 16px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Background with gradient */}
      <div
        className="absolute transition-transform duration-500"
        style={{
          background:
            "linear-gradient(145deg, var(--color-bg-primary) 10.21%, #FFAD73 85.25%)",
          borderRadius: "50%",
          opacity: 0.95,
          right: "-15%",
          bottom: "-34%",
          width: "70%",
          height: "70%",
          transform: `scale(${isHovered ? 1.02 : 1})`,
          transformOrigin: "bottom right",
        }}
      />

      <div className="relative flex flex-col flex-grow">
        {/* Title with animation */}
        <h2 className="text-2xl font-bold mb-8 text-text-primary">
          Weekly Contest
        </h2>

        {/* Description with animation */}
        <div className="flex justify-between relative items-center mb-10">
          <p className="text-text-secondary mr-8">
            Practice with weekly contests and improve your skills. And Earn $30
            Cash!
          </p>
          {/* <img
            src={cancelIcon}
            className="w-5 h-5 absolute top-1/3 right-0 ml-10 transition-transform duration-300"
            style={{
              transform: isHovered ? "scale(1.1)" : "scale(1)",
            }}
          /> */}
        </div>

        {/* view Button */}
        <div className="mt-auto">
          <Button
            onClick={() => {
              navigate("/weekly-contest");
            }}
            className="
      group
      relative
      inline-flex
      items-center
      justify-center
      border
      border-gray-300
      px-8
      py-2
      bg-bg-primary
      text-text-primary
      rounded
      transition-colors
      duration-100
      hover:bg-orange-600
      hover:text-white
    "
          >
            <span className="transition-all">View</span>
            <ArrowRight
              size={18}
              className="
        absolute
        right-4
        opacity-0
        -translate-x-2
        transition-all
        duration-300
        group-hover:opacity-100
        group-hover:translate-x-2
      "
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WeeklyContestCard;
